import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["applications"],
  _excluded2 = ["clientUsername", "applicationId", "type"],
  _excluded3 = ["clientUsername", "applicationId", "clientApplicationRequestId", "status"];
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-console */
import moment from "moment";
import { MORTGAGE_TYPE_PARSER } from "@Shared/js/constants";
import { ADD_CLIENT_APPLICATION, SET_VISIBILITY_CURRENT_APPLICATION, CLEAR_CURRENT_SCHEMA, E_SIGNATURE_SET_DOCUMENTS, E_SIGNATURE_SET_REQUESTED_SIGNATURES, INSERT_APPLICATION_GROUP_ITEM, SET_APPLICATION_GROUP_ITEM, REDIRECT_TO_CLIENT, REMOVE_APPLICATION_GROUP_ITEM, REMOVE_APPLICATION_PAGE_DATA, REPLICATE_APPLICATION_GROUP_ITEM, SET_APPLICANT_OTHER_PROPERTIES, SET_APPLICATION_LOCK_STATUS, SET_APPLICATION_READ_STATUS, SET_APPLICATION_SUBMISSION_AGENT, SET_CALCULATED_VALUES, SET_CALCULATED_VALUES_LOADING_STATUS, SET_CALCULATIONS_DATA, SET_CLIENT_DETAILS, SET_CLIENT_REQUEST_EMAIL, SET_CURRENT_APPLICATION, SET_CURRENT_APPLICATION_UPDATED_TIME, SET_EMPTY_APPLICATION, SET_REQUEST_DATA_DETAILS, SET_SCHEMA, SET_E_SIGN_TEMPLATES, TOGGLE_APPLICATION_LOCK_STATUS, TOGGLE_APPLICATION_SAVING_STATUS, TOGGLE_SCHEMA_SAVING_STATUS, UPDATE_APPLICATION_DETAILS, SET_APPLICATION_OWNER, MARK_APPLICATION_GROUP_VISIBILITY, SET_MORTGAGE_LENDER, SET_FILOGIX_DEALS, SET_FILOGIX_DEAL_STATUS, SET_FILOGIX_SUBMITTING, UPDATE_E_SIGN_TEMPLATE, ADD_E_SIGN_TEMPLATE, E_SIGN_REMOVE_TEMPLATE, REMOVE_APPLICATION, SET_MUTED_AUTOMATIONS, SET_APPLICATION_SUBSCRIPTION_INFO, REQUEST_PACKAGE_SET_REQUESTED_PACKAGES, SET_APPLICATION_SYNC_STATUS, SET_APPLICATION_SYNCABLE_STATUS, SET_APPLICATION_VALIDATIONS, SET_CURRENT_APPLICATION_ID, SET_CUSTOMIZATION_SCHEMA, TOGGLE_SCHEMA_RESETTING_STATUS, SET_IS_DEFAULT_CUSTOMIZATION_SCHEMA, SET_GENERATED_LENDER_NOTE, SET_WAITING_FOR_GENERATED_LENDER_NOTE, SET_DEAL_TYPE, SET_INSURANCE_SUBMISSION_HISTORY, SET_INSURANCE_PROVIDERS } from "./application-mutations";
import { applicationsSchema, clientApplicationRequestSchema, documentSchema, filogixSubmissionSchema, eSignTemplatesSchema, requestedPackagesSchema } from "./application-schema";
import { completeApplication, deleteUserDataRequest, getApplicationData, getBankStatements, getCalculatedValues, getCalculationsData, getClientData, getClientRequestEmail, getDocumentClassifications, getFullSIN, getSchema, getUserDataRequest, getEsignTemplates, markApplicationAsRead, putUserDataRequest, sendUserDataRequest, shareApplication, toggleApplicationLock, updateApplication, updateSchema, createRequestPackage, getFilogixDeals, updateFilogixDeal, updateFilogixDealStatus, submitFilogixDeal, syncFilogixDealApplication, previewRequestPackage, createEsignTemplate, markEsignTemplateAsComplete, deleteEsignTemplate, editESignTemplate, sendClientRequestReminder, deleteApplication, getMutedAutomations, updateMutedAutomations, swapApplicants, syncSubmissionAgentFromExpert, getApplicationSyncStatus, retryApplicationSync, syncApplicationToClientProfile, getCustomizationSchema, updateCustomizationSchema, updateCustomizationBrokerageSchema, getCustomizationBrokerageSchema, resetCustomizationBrokerageSchema, resetCustomizationSchema, submitInsuranceRequest, getInsuranceSubmissionsHistory, getInsuranceProviders } from "../api/application-api";
import { getSignedURL, markUploadCompleted } from "../../documents/api/documents-api";
import { getSubmissionAgents } from "@Broker/@Modules/clients/applications/application/api/lender-submit-api";
import { submissionAgentsSchema } from "@Broker/@Modules/clients/applications/application/store/lender-submit-schema";
import { SET_SUBMISSION_AGENTS } from "@Broker/@Modules/clients/applications/application/store/lender-submit-mutations";
import { putS3Data } from "@Shared/utils/ajax";
import ApplicationGenerator from "@Shared/utils/application-generator";
import Err from "../../../../../routes/error";
import { normalize } from "normalizr";
import { removeEmptyKeys } from "@Shared/utils/utils";
import Amplitude from "@Shared/utils/amplitude";
import { MAP_COMPLETE_TO_APPLICATION_STATUS } from "@Shared/js/map";
import { createAdditionalApplication } from "../api/applications-list-api";
import Vue from "vue";
import { chain, cloneDeep, get, isEmpty, map } from "lodash";
import ApplicationValidationsGenerator from "@Shared/@Utils/application-validation-generator";
import { STORE_NAME } from "./application-helpers";
import { showToast, EXTENDED_TOASTR_OPTIONS } from "@Shared/@Utils/constants";
export const CHANGE_CURRENT_FLOW = "CHANGE_CURRENT_FLOW";
export const UPDATE_APPLICATION_FLOW = "UPDATE_APPLICATION_FLOW";
export const LOAD_APPLICATION_DATA = "LOAD_APPLICATION_DATA";
export const ADD_ADDITIONAL_APPLICATION = "ADD_ADDITIONAL_APPLICATION";
export const LOAD_CLIENT_DATA = "LOAD_CLIENT_DATA";
export const SAVE_CLIENT_USERNAME = "SAVE_CLIENT_USERNAME";
export const LOAD_CALCULATIONS_DATA = "LOAD_CALCULATIONS_DATA";
export const UPDATE_APP_DEAL_STATUS = "UPDATE_APP_DEAL_STATUS";
export const CHANGE_OTHER_PROPERTIES = "CHANGE_OTHER_PROPERTIES";
export const LOAD_CLIENT_REQUEST_EMAIL_DATA = "LOAD_CLIENT_REQUEST_EMAIL_DATA";
export const SHARE_APPLICATION = "SHARE_APPLICATION";
export const LOAD_USER_DATA_REQUEST_DETAILS = "LOAD_USER_DATA_REQUEST_DETAILS";
export const SEND_USER_DATA_REQUEST = "SEND_USER_DATA_REQUEST";
export const TOGGLE_APPLICATION_LOCK = "TOGGLE_APPLICATION_LOCK";
export const ADD_APPLICATION_GROUP = "ADD_APPLICATION_GROUP";
export const REMOVE_APPLICATION_GROUP = "REMOVE_APPLICATION_GROUP";
export const REMOVE_APPLICATION_PAGE = "REMOVE_APPLICATION_PAGE";
export const REPLICATE_APPLICATION_GROUP = "REPLICATE_APPLICATION_GROUP";
export const SAVE_CURRENT_APPLICATION = "SAVE_CURRENT_APPLICATION";
export const LOAD_CALCULATED_VALUES = "LOAD_CALCULATED_VALUES";
export const SHOW_FULL_SIN = "SHOW_FULL_SIN";
export const CHANGE_PROPERTY_VALUE = "CHANGE_PROPERTY_VALUE";
export const LOAD_EMPTY_APPLICATION = "LOAD_EMPTY_APPLICATION";
export const UPDATE_SCHEMA = "UPDATE_SCHEMA";
export const UPDATE_CUSTOMIZATION_SCHEMA = "UPDATE_CUSTOMIZATION_SCHEMA";
export const RESET_CUSTOMIZATION_SCHEMA = "RESET_CUSTOMIZATION_SCHEMA";
export const MARK_APPLICATION_AS_READ = "MARK_APPLICATION_AS_READ";
export const E_SIGNATURE_LOAD_DOCUMENTS = "E_SIGNATURE_LOAD_DOCUMENTS";
export const E_SIGNATURE_LOAD_REQUESTED_SIGNATURES = "E_SIGNATURE_LOAD_REQUESTED_SIGNATURES";
export const E_SIGNATURE_UPDATE_STATUS = "E_SIGNATURE_UPDATE_STATUS";
export const E_SIGNATURE_DELETE_REQUEST = "E_SIGNATURE_DELETE_REQUEST";
export const E_SIGNATURE_SEND_REMINDER = "E_SIGNATURE_SEND_REMINDER";
export const E_SIGN_CREATE_TEMPLATE = "E_SIGN_CREATE_TEMPLATE";
export const E_SIGN_EDIT_TEMPLATE = "E_SIGN_EDIT_TEMPLATE";
export const E_SIGN_LOAD_TEMPLATES = "E_SIGN_LOAD_TEMPLATES";
export const E_SIGN_DELETE_TEMPLATE = "E_SIGN_DELETE_TEMPLATE";
export const E_SIGN_MARK_TEMPLATE_AS_COMPLETE = "E_SIGN_MARK_TEMPLATE_AS_COMPLETE";
export const E_SIGN_UPLOAD_DOCUMENT_TEMPLATE = "E_SIGN_UPLOAD_DOCUMENT_TEMPLATE";
export const CREATE_REQUEST_PACKAGE = "CREATE_REQUEST_PACKAGE";
export const LOAD_PREVIEW_REQUEST_PACKAGE = "LOAD_PREVIEW_REQUEST_PACKAGE";
export const CHANGE_MORTGAGE_LENDER = "CHANGE_MORTGAGE_LENDER";
export const LOAD_FILOGIX_SUBMISSIONS = "LOAD_FILOGIX_SUBMISSIONS";
export const UPDATE_FILOGIX_SUBMISSION = "UPDATE_FILOGIX_SUBMISSION";
export const UPDATE_FILOGIX_SUBMISSION_STATUS = "UPDATE_FILOGIX_SUBMISSION_STATUS";
export const TOGGLE_FILOGIX_SUBMISSION_PROGRESS = "TOGGLE_FILOGIX_SUBMISSION_PROGRESS";
export const SUBMIT_TO_FILOGIX = "SUBMIT_TO_FILOGIX";
export const SYNC_WITH_FILOGIX = "SYNC_WITH_FILOGIX";
export const LOAD_SCHEMA = "LOAD_SCHEMA";
export const LOAD_CUSTOMIZATION_SCHEMA = "LOAD_CUSTOMIZATION_SCHEMA";
export const SET_APPLICATION_STATUS = "SET_APPLICATION_STATUS";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const LOAD_MUTED_AUTOMATIONS = "LOAD_MUTED_AUTOMATIONS";
export const UPDATE_MUTED_AUTOMATIONS = "UPDATE_MUTED_AUTOMATIONS";
export const LOAD_APPLICATION_SUBSCRIPTION_INFO = "LOAD_APPLICATION_SUBSCRIPTION_INFO";
export const SWAP_APPLICANT = "SWAP_APPLICANT";
export const LOAD_REQUESTED_PACKAGES = "LOAD_REQUESTED_PACKAGES";
export const SYNC_AGENT_FROM_EXPERT = "SYNC_AGENT_FROM_EXPERT";
export const LOAD_APPLICATION_SYNC_STATUS = "LOAD_APPLICATION_SYNC_STATUS";
export const LOAD_APPLICATION_SYNC_HISTORY = "LOAD_APPLICATION_SYNC_HISTORY";
export const RETRY_APPLICATION_SYNC = "RETRY_APPLICATION_SYNC";
export const SYNC_APPLICATION_TO_CLIENT_PROFILE = "SYNC_APPLICATION_TO_CLIENT_PROFILE";
export const DEAL_IMPORT_COMPLETE_NOTIFICATION = "DEAL_IMPORT_COMPLETE_NOTIFICATION";
export const UPDATE_GENERATED_LENDER_NOTE = "UPDATE_GENERATED_LENDER_NOTE";
export const RESET_DEAL_TYPE = "RESET_DEAL_TYPE";
export const SUBMIT_INSURANCE_REQUEST = "SUBMIT_INSURANCE_REQUEST";
export const GET_INSURANCE_SUBMISSIONS_HISTORY = "GET_INSURANCE_SUBMISSIONS_HISTORY";
export const LOAD_INSURANCE_PROVIDERS = "LOAD_INSURANCE_PROVIDERS";
export default {
  [UPDATE_APPLICATION_FLOW]: async (context, {
    applicationId,
    clientUsername,
    flow
  }) => {
    const currentApplication = context.getters["CURRENT_APPLICATION"];
    const {
      flow: oldFlow
    } = currentApplication;

    // If applicationId is falsy, the action was called
    // from the Application Form Customization page
    if (!applicationId) {
      await context.dispatch(LOAD_EMPTY_APPLICATION, {
        flow
      });
      return context.commit(SET_VISIBILITY_CURRENT_APPLICATION, {
        flow
      });
    }
    const emptyApplicationEmptyOnChangedFlow = isEmpty(context.state.emptyApplication[flow]);
    if (emptyApplicationEmptyOnChangedFlow) {
      await context.dispatch(LOAD_EMPTY_APPLICATION, {
        flow
      });
    }
    context.commit(UPDATE_APPLICATION_DETAILS, {
      applicationId,
      flow
    });
    context.commit(SET_CURRENT_APPLICATION, {
      application: context.state.applications.byId[applicationId] || {},
      emptyApplication: cloneDeep(context.state.emptyApplication[flow]),
      applicationId
    });
    try {
      const isApplicationEmpty = isEmpty(currentApplication);
      if (!isApplicationEmpty) {
        await updateApplication(_objectSpread(_objectSpread({}, cloneDeep(currentApplication)), {}, {
          flow
        }), applicationId, clientUsername);
        Amplitude.logVuexActionEvent("Broker Application flow saved", {
          type: `${STORE_NAME}/${UPDATE_APPLICATION_FLOW}`,
          payload: {
            applicationId,
            clientUsername,
            flow
          }
        });
      }
    } catch (e) {
      context.commit(UPDATE_APPLICATION_DETAILS, {
        applicationId,
        flow: oldFlow
      });
      throw e;
    }
  },
  [UPDATE_GENERATED_LENDER_NOTE]: (context, {
    lenderNote,
    applicationId
  }) => {
    if (context.state.waitingForGeneratedLenderNote && context.state.currentApplicationId == applicationId) {
      context.commit(SET_GENERATED_LENDER_NOTE, lenderNote);
      context.commit(SET_WAITING_FOR_GENERATED_LENDER_NOTE, false);
    }
  },
  [LOAD_EMPTY_APPLICATION]: async (context, {
    flow,
    isBrokerage = false,
    ignoreEmptyCheck = false
  }) => {
    if (ignoreEmptyCheck) {
      context.commit(CLEAR_CURRENT_SCHEMA);
    }
    let emptyApplication = context.state.emptyApplication[flow];
    if (isEmpty(removeEmptyKeys(emptyApplication))) {
      let schema = context.state.schema;
      if (isEmpty(removeEmptyKeys(schema))) {
        schema = await getSchema(isBrokerage);
        context.commit(SET_SCHEMA, schema);
      }
      const generator = new ApplicationGenerator(schema);
      const {
        application: generatedApplication
      } = generator.buildApp(flow);
      const validationsGenerator = new ApplicationValidationsGenerator(schema, {
        ignoreRequired: true,
        generateGroupValidations: false,
        ignoreVisibility: true
      });
      const {
        application: applicationValidations
      } = validationsGenerator.buildAppValidations(flow);
      context.commit(SET_APPLICATION_VALIDATIONS, {
        validations: applicationValidations
      });
      emptyApplication = generatedApplication;
      emptyApplication["submission-details"][0]["submission-details"]["variable-to-prime"] = "";
      context.commit(SET_EMPTY_APPLICATION, {
        flow: flow,
        emptyApplication: cloneDeep(emptyApplication)
      });
    }
    return cloneDeep(emptyApplication);
  },
  [UPDATE_SCHEMA]: async (context, {
    isBrokerage
  }) => {
    try {
      const nonSchemaKeys = ["showDirectToLender", "saving"];
      context.commit(TOGGLE_SCHEMA_SAVING_STATUS, {
        saving: true
      });
      await updateSchema(isBrokerage, chain(context.state.schema).cloneDeep().omitBy((value, key) => _includesInstanceProperty(nonSchemaKeys).call(nonSchemaKeys, key)).value());
      context.commit(TOGGLE_SCHEMA_SAVING_STATUS, {
        saving: false
      });
    } catch (e) {
      context.commit(TOGGLE_SCHEMA_SAVING_STATUS, {
        saving: false,
        error: true
      });
      Amplitude.logHandledError(e, {}, e.responseJSON.message);
    }
  },
  [UPDATE_CUSTOMIZATION_SCHEMA]: async (context, {
    isBrokerage
  }) => {
    try {
      const nonSchemaKeys = ["showDirectToLender", "saving", "translationMap", "isDefaultSchema"];
      context.commit(TOGGLE_SCHEMA_SAVING_STATUS, {
        saving: true
      });
      let response;
      if (isBrokerage) {
        response = await updateCustomizationBrokerageSchema(chain(context.state.customizationSchema).cloneDeep().omitBy((value, key) => _includesInstanceProperty(nonSchemaKeys).call(nonSchemaKeys, key)).value());
      } else {
        response = await updateCustomizationSchema(chain(context.state.customizationSchema).cloneDeep().omitBy((value, key) => _includesInstanceProperty(nonSchemaKeys).call(nonSchemaKeys, key)).value());
      }
      context.commit(SET_IS_DEFAULT_CUSTOMIZATION_SCHEMA, response);
      context.commit(TOGGLE_SCHEMA_SAVING_STATUS, {
        saving: false
      });
    } catch (e) {
      context.commit(TOGGLE_SCHEMA_SAVING_STATUS, {
        saving: false,
        error: true
      });
      Amplitude.logHandledError(e, {}, e.responseJSON.message);
    }
  },
  [RESET_CUSTOMIZATION_SCHEMA]: async (context, {
    isBrokerage
  }) => {
    try {
      context.commit(TOGGLE_SCHEMA_RESETTING_STATUS, {
        resetting: true
      });
      let schema = {};
      if (isBrokerage) {
        await resetCustomizationBrokerageSchema();
        schema = await getCustomizationBrokerageSchema();
      } else {
        await resetCustomizationSchema();
        schema = await getCustomizationSchema();
      }
      context.commit(SET_CUSTOMIZATION_SCHEMA, schema);
      context.commit(TOGGLE_SCHEMA_RESETTING_STATUS, {
        resetting: false
      });
    } catch (e) {
      context.commit(TOGGLE_SCHEMA_RESETTING_STATUS, {
        resetting: false,
        error: true
      });
      Amplitude.logHandledError(e, {}, e.responseJSON.message);
    }
  },
  [LOAD_APPLICATION_DATA]: async (context, {
    clientUsername,
    agentUsername,
    applicationId,
    clientProfileId
  }) => {
    context.commit(SET_CURRENT_APPLICATION_ID, {
      applicationId
    });
    const applicationFromState = context.state.applications.byId[applicationId];
    const {
      read,
      locked,
      updatedAt,
      application,
      applicationStatus,
      appSubStatus,
      submissionAgentId,
      linkedProfiles,
      appOwnerDetails,
      accountDetails: clientDetails,
      mortgageRenewalDate,
      syncable,
      referrerId,
      cobrokeredMortgages = null,
      isCobrokeredApplication = false
    } = applicationFromState ? _objectSpread(_objectSpread({}, applicationFromState), {}, {
      application: applicationFromState
    }) : await getApplicationData(clientUsername, applicationId, agentUsername, clientProfileId);
    const emptyApplication = await context.dispatch(LOAD_EMPTY_APPLICATION, {
      flow: application.flow
    });
    context.commit(SET_CLIENT_DETAILS, {
      clientUsername,
      clientData: clientDetails
    });
    context.commit(SET_CURRENT_APPLICATION, {
      application: _objectSpread(_objectSpread({}, application), {}, {
        applicationStatus,
        appSubStatus,
        linkedProfiles,
        read,
        referrerId,
        mortgageRenewalDate,
        cobrokeredMortgages,
        isCobrokeredApplication
      }),
      emptyApplication: cloneDeep(emptyApplication),
      applicationId
    });
    context.commit(SET_APPLICATION_LOCK_STATUS, {
      locked
    });
    context.commit(SET_APPLICATION_SUBMISSION_AGENT, {
      submissionAgentId
    });
    context.commit(SET_APPLICATION_OWNER, {
      appOwnerDetails
    });
    context.commit(SET_CURRENT_APPLICATION_UPDATED_TIME, {
      applicationId,
      updatedAt
    });
    context.commit(SET_APPLICATION_SYNCABLE_STATUS, {
      applicationId,
      syncable
    });
    if (applicationFromState) {
      //silently update data
      getApplicationData(clientUsername, applicationId, agentUsername).then(({
        locked,
        updatedAt,
        application,
        username,
        submissionAgentId,
        accountDetails: clientDetails,
        linkedProfiles,
        applicationStatus,
        syncable,
        referrerId,
        isCobrokeredApplication = false
      }) => {
        if (username) {
          return context.commit(REDIRECT_TO_CLIENT, {
            clientUsername: username
          });
        }
        context.commit(SET_CURRENT_APPLICATION, {
          application: _objectSpread(_objectSpread({}, application), {}, {
            applicationStatus,
            linkedProfiles,
            referrerId,
            loading: false,
            isCobrokeredApplication
          }),
          emptyApplication: cloneDeep(emptyApplication),
          applicationId
        });
        context.commit(SET_APPLICATION_SUBMISSION_AGENT, {
          submissionAgentId
        });
        context.commit(SET_APPLICATION_OWNER, {
          appOwnerDetails
        });
        context.commit(SET_APPLICATION_LOCK_STATUS, {
          locked
        });
        context.commit(SET_CURRENT_APPLICATION_UPDATED_TIME, {
          applicationId,
          updatedAt
        });
        context.commit(SET_CLIENT_DETAILS, {
          clientUsername,
          clientData: clientDetails
        });
        context.commit(SET_APPLICATION_SYNCABLE_STATUS, {
          applicationId,
          syncable
        });
      });
    }
    Amplitude.logVuexActionEvent("Broker Application application data loaded", {
      type: `${STORE_NAME}/${LOAD_APPLICATION_DATA}`
    });
  },
  [LOAD_CLIENT_DATA]: async (context, {
    clientUsername,
    agentUsername,
    clientProfileId,
    applicationId
  }) => {
    const _await$getClientData = await getClientData(clientUsername, agentUsername, clientProfileId, applicationId),
      {
        applications
      } = _await$getClientData,
      clientData = _objectWithoutProperties(_await$getClientData, _excluded);
    if (clientData.username) {
      Amplitude.logVuexActionEvent("Broker Application client redirected by collapse", {
        type: `${STORE_NAME}/${LOAD_CLIENT_DATA}`,
        payload: {
          clientUsername,
          agentUsername,
          clientProfileId,
          applicationId
        }
      });
      return context.commit(REDIRECT_TO_CLIENT, {
        clientUsername: clientData.username
      });
    }
    const {
      entities,
      result
    } = normalize(applications, [applicationsSchema]);
    context.commit(SET_CLIENT_DETAILS, {
      clientUsername,
      clientData,
      applications: {
        byId: entities.applications || {},
        allIds: result
      }
    });
    Amplitude.logVuexActionEvent("Broker Application client data loaded", {
      type: `${STORE_NAME}/${LOAD_CLIENT_DATA}`,
      payload: {
        clientUsername,
        agentUsername,
        clientProfileId,
        applicationId
      }
    });
  },
  [SHOW_FULL_SIN]: async (context, {
    applicationId,
    clientUsername,
    applicantIndex
  }) => {
    const path = applicantIndex === 0 ? "main-applicant" : `co-applicants[${applicantIndex - 1}]`;
    const currentSIN = get(context.state.application, `${path}[personal-details][sin]`);
    let sin = [];
    if (currentSIN && currentSIN[3] !== "XXX") {
      sin = {
        1: currentSIN[1],
        2: currentSIN[2],
        3: currentSIN[3]
      };
    } else {
      ({
        sin
      } = await getFullSIN(applicationId, clientUsername, applicantIndex));
    }
    context.commit("setDetails", {
      param: `${path}[personal-details]`,
      path: "sin",
      value: sin
    });
  },
  [ADD_ADDITIONAL_APPLICATION]: async (context, {
    clientUsername,
    agentUsername,
    clientProfileId,
    data
  }) => {
    const {
      applicationId
    } = await createAdditionalApplication(data, clientUsername, agentUsername, clientProfileId);
    if (!context.state.clients[clientUsername]) {
      await context.dispatch(LOAD_CLIENT_DATA, {
        clientUsername,
        agentUsername,
        clientProfileId,
        applicationId
      });
    }
    context.commit(ADD_CLIENT_APPLICATION, {
      clientUsername,
      applicationId,
      applicationData: _objectSpread(_objectSpread({}, data), {}, {
        applicationId,
        applicationStatus: "pending",
        coapps: null,
        consentObtainedDate: null,
        consentStatus: "not-obtained",
        createdAt: moment(),
        locked: false,
        mortgageAmount: null,
        propertyAddress: null,
        shared: false
      })
    });
    Amplitude.logVuexActionEvent("Broker Application additional application created", {
      type: `${STORE_NAME}/${ADD_ADDITIONAL_APPLICATION}`,
      payload: {
        clientUsername,
        agentUsername,
        clientProfileId,
        data
      }
    });
    return applicationId;
  },
  [LOAD_CALCULATIONS_DATA]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const {
      calculations
    } = await getCalculationsData(applicationId, clientUsername);
    context.commit(SET_CALCULATIONS_DATA, {
      calculations
    });
  },
  [LOAD_CALCULATED_VALUES]: async (context, {
    clientUsername,
    applicationId
  }) => {
    context.commit(SET_CALCULATED_VALUES_LOADING_STATUS, {
      loading: true
    });
    const {
      calculations
    } = await getCalculatedValues(applicationId, clientUsername);
    context.commit(SET_CALCULATED_VALUES, {
      calculations
    });
    context.commit(SET_CALCULATED_VALUES_LOADING_STATUS, {
      loading: false
    });
  },
  [UPDATE_APP_DEAL_STATUS]: async (context, {
    status,
    applicationId,
    clientUsername
  }) => {
    await completeApplication(status, clientUsername, applicationId);
  },
  [CHANGE_OTHER_PROPERTIES]: (context, dataByApplicant) => {
    for (const key in dataByApplicant) {
      context.commit(SET_APPLICANT_OTHER_PROPERTIES, {
        applicant: key === "0" ? "main-applicant" : `co-applicants[${key - 1}]`,
        properties: dataByApplicant[key]
      });
    }
  },
  [LOAD_CLIENT_REQUEST_EMAIL_DATA]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const {
      email: clientRequestEmail
    } = await getClientRequestEmail(applicationId, clientUsername);
    context.commit(SET_CLIENT_REQUEST_EMAIL, {
      clientRequestEmail
    });
  },
  [LOAD_USER_DATA_REQUEST_DETAILS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    const {
      email: requestDataEmail
    } = await getBankStatements(applicationId, clientUsername);
    const application = context.state.applications.byId[applicationId];
    const {
      "first-name": givenName,
      "last-name": familyName
    } = application["main-applicant"]["personal-details"];
    context.commit(SET_REQUEST_DATA_DETAILS, {
      requestDataEmail,
      requestDataName: `${givenName} ${familyName}`
    });
  },
  [SEND_USER_DATA_REQUEST]: async (context, _ref) => {
    let {
        clientUsername,
        applicationId,
        type
      } = _ref,
      data = _objectWithoutProperties(_ref, _excluded2);
    try {
      const response = await sendUserDataRequest(applicationId, clientUsername, type, data);
      Amplitude.logEvent("Applications - user data request sent", {
        page: "clients-applications",
        applicationId,
        clientUsername,
        type
      });
      return response;
    } catch (e) {
      Amplitude.logHandledError(e, {
        clientUsername,
        applicationId
      });
      throw e;
    }
  },
  [SHARE_APPLICATION]: async (context, {
    clientUsername,
    applicationId,
    emailToSend
  }) => {
    try {
      const {
        username
      } = await shareApplication(applicationId, clientUsername, emailToSend);
      Amplitude.logEvent("Applications - application shared with client", {
        page: "clients-applications",
        applicationId,
        client: emailToSend
      });
      if (username) {
        return context.commit(REDIRECT_TO_CLIENT, {
          clientUsername: username
        });
      }
    } catch (e) {
      Amplitude.logHandledError(e, {
        clientUsername,
        applicationId,
        emailToSend
      });
      throw e;
    }
  },
  [LOAD_PREVIEW_REQUEST_PACKAGE]: async (context, {
    clientUsername,
    applicationId,
    payload
  }) => {
    try {
      const response = await previewRequestPackage(applicationId, clientUsername, payload);
      return response;
    } catch (e) {
      Err.handle(e, {
        page: "clients-applications",
        applicationId,
        data: payload
      });
      throw e;
    }
  },
  [CREATE_REQUEST_PACKAGE]: async (context, {
    clientUsername,
    applicationId,
    payload
  }) => {
    try {
      const {
        response
      } = await createRequestPackage(applicationId, clientUsername, payload);
      const {
        username
      } = (response == null ? void 0 : response[0]) || {};
      Amplitude.logEvent("Application - Request Package Created Successfully", {
        page: "clients-applications",
        applicationId,
        data: payload
      });
      if (username) {
        return context.commit(REDIRECT_TO_CLIENT, {
          clientUsername: username
        });
      }
    } catch (e) {
      Err.handle(e, {
        page: "clients-applications",
        applicationId,
        data: payload
      });
      throw e;
    }
  },
  [TOGGLE_APPLICATION_LOCK]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      await toggleApplicationLock(applicationId, clientUsername);
      context.commit(TOGGLE_APPLICATION_LOCK_STATUS, {});
    } catch (e) {
      Amplitude.logHandledError(e, {
        applicationId,
        clientUsername
      });
      throw e;
    }
  },
  [MARK_APPLICATION_AS_READ]: async (context, {
    clientUsername,
    agentUsername
  }) => {
    const {
      username
    } = Vue.auth.session.get().userDetails;
    try {
      if (username === agentUsername) {
        context.commit(SET_APPLICATION_READ_STATUS, {
          read: true
        });
        await markApplicationAsRead(clientUsername);
      }
    } catch (e) {
      Amplitude.logHandledError(e, {
        clientUsername,
        agentUsername
      });
      context.commit(SET_APPLICATION_READ_STATUS, {
        read: false
      });
    }
  },
  [ADD_APPLICATION_GROUP]: async (context, {
    what,
    where,
    markAsVisible,
    startEmpty,
    amountItems = 1
  }) => {
    if (startEmpty && markAsVisible) {
      context.commit(SET_APPLICATION_GROUP_ITEM, {
        what,
        where,
        amountItems
      });
      return context.commit(MARK_APPLICATION_GROUP_VISIBILITY, {
        where,
        visibility: true
      });
    }
    context.commit(INSERT_APPLICATION_GROUP_ITEM, {
      what,
      where,
      amountItems
    });
  },
  [REMOVE_APPLICATION_GROUP]: async (context, {
    where,
    index,
    startEmpty
  }) => {
    context.commit(REMOVE_APPLICATION_GROUP_ITEM, {
      where,
      index,
      startEmpty
    });
  },
  [REMOVE_APPLICATION_PAGE]: async (context, {
    page
  }) => {
    context.commit(REMOVE_APPLICATION_PAGE_DATA, {
      page
    });
  },
  [REPLICATE_APPLICATION_GROUP]: (context, payload) => {
    context.commit(REPLICATE_APPLICATION_GROUP_ITEM, payload);
  },
  [SAVE_CURRENT_APPLICATION]: async (context, {
    applicationId,
    clientUsername,
    reFetchCalculations
  }) => {
    try {
      if (reFetchCalculations) {
        context.commit(SET_CALCULATED_VALUES_LOADING_STATUS, {
          loading: true
        });
      }
      const currentApplication = context.getters["CURRENT_APPLICATION"];
      const isApplicationEmpty = isEmpty(currentApplication);
      context.commit(TOGGLE_APPLICATION_SAVING_STATUS, {
        saving: true
      });
      if (!isApplicationEmpty) {
        const calculations = await updateApplication(cloneDeep(currentApplication), applicationId, clientUsername, reFetchCalculations);
        if (reFetchCalculations) {
          context.commit(SET_CALCULATED_VALUES, {
            calculations: calculations.raw
          });
          context.commit(SET_CALCULATED_VALUES_LOADING_STATUS, {
            loading: false
          });
          context.commit(SET_CALCULATIONS_DATA, {
            calculations: calculations.formatted
          });
        }
        Amplitude.logVuexActionEvent("Broker Application application saved", {
          type: `${STORE_NAME}/${SAVE_CURRENT_APPLICATION}`,
          payload: {
            applicationId,
            clientUsername,
            reFetchCalculations
          }
        });
      }
    } finally {
      context.commit(SET_CURRENT_APPLICATION_UPDATED_TIME, {
        applicationId,
        updatedAt: moment().format()
      });
      context.commit(TOGGLE_APPLICATION_SAVING_STATUS, {
        saving: false
      });
    }
  },
  [E_SIGNATURE_LOAD_DOCUMENTS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const promises = [getDocumentClassifications(applicationId, clientUsername)]; //TODO add forms to this promise array
      const [documentClassifications] = await _Promise.all(promises);
      const {
        documents
      } = documentClassifications;
      const documentList = _flatMapInstanceProperty(documents).call(documents, ({
        documents: d
      }) => d);
      const normalizesDocuments = normalize(documentList, [documentSchema]);
      const availableDocuments = {
        byId: normalizesDocuments.entities.documents || {},
        allIds: normalizesDocuments.result
      };
      context.commit(E_SIGNATURE_SET_DOCUMENTS, {
        availableDocuments
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [E_SIGNATURE_LOAD_REQUESTED_SIGNATURES]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const {
        clientApplicationRequests
      } = await getUserDataRequest(applicationId, clientUsername, "e-sign");
      const {
        entities,
        result
      } = normalize(clientApplicationRequests, [clientApplicationRequestSchema]);
      context.commit(E_SIGNATURE_SET_REQUESTED_SIGNATURES, {
        clientApplicationRequests: {
          byId: entities.clientApplicationRequests || {},
          allIds: result
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [E_SIGNATURE_UPDATE_STATUS]: async (context, _ref2) => {
    let {
        clientUsername,
        applicationId,
        clientApplicationRequestId,
        status
      } = _ref2,
      data = _objectWithoutProperties(_ref2, _excluded3);
    try {
      await putUserDataRequest(applicationId, clientUsername, clientApplicationRequestId, _objectSpread({
        status
      }, data));
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [E_SIGNATURE_SEND_REMINDER]: async (context, {
    clientUsername,
    applicationId,
    clientApplicationRequestId
  }) => {
    try {
      await sendClientRequestReminder(applicationId, clientUsername, clientApplicationRequestId);
      Amplitude.logEvent("E-Sign: Sent Reminder", {
        clientApplicationRequestId,
        applicationId,
        clientUsername
      });
    } catch (e) {
      Amplitude.logEvent("E-Sign: Failed to sent reminder", {
        clientApplicationRequestId,
        applicationId,
        clientUsername
      });
      throw e;
    }
  },
  [E_SIGNATURE_DELETE_REQUEST]: async (context, {
    clientUsername,
    applicationId,
    clientApplicationRequestId
  }) => {
    try {
      await deleteUserDataRequest(applicationId, clientUsername, clientApplicationRequestId);
      Amplitude.logEvent("E-Sign: Deleted request", {
        clientApplicationRequestId,
        applicationId,
        clientUsername
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [E_SIGN_CREATE_TEMPLATE]: async (context, {
    templateData
  }) => {
    try {
      const response = await createEsignTemplate(templateData);
      const newTemplateData = _objectSpread(_objectSpread({}, templateData), {}, {
        eSignTemplateId: response.eSignTemplateId,
        expired: false,
        createdAt: moment(),
        updatedAt: moment()
      });
      Amplitude.logEvent("E-Sign: Created Template", {
        templateData
      });
      context.commit(ADD_E_SIGN_TEMPLATE, newTemplateData);
      return response;
    } catch (e) {
      Err.handle(e);
    }
  },
  [E_SIGN_EDIT_TEMPLATE]: async (context, {
    templateId
  }) => {
    try {
      return await editESignTemplate(templateId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [E_SIGN_MARK_TEMPLATE_AS_COMPLETE]: async (context, {
    templateData
  }) => {
    try {
      const {
        templateId
      } = templateData;
      const selectedTemplate = context.state.eSign.templates.byId[templateData.eSignTemplateId];
      const templateMarkedAsComplete = _objectSpread(_objectSpread({}, selectedTemplate), {}, {
        complete: true,
        templateId
      });
      await markEsignTemplateAsComplete(templateData.eSignTemplateId);
      context.commit(UPDATE_E_SIGN_TEMPLATE, templateMarkedAsComplete);
      Amplitude.logEvent("E-Sign: Completed Template", {
        templateData
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [E_SIGN_LOAD_TEMPLATES]: async context => {
    try {
      const {
        templates
      } = await getEsignTemplates();
      const templatesWithoutMetaData = map(templates, template => _objectSpread(_objectSpread({}, template), template.metadata));
      const {
        entities,
        result
      } = normalize(templatesWithoutMetaData, [eSignTemplatesSchema]);
      context.commit(SET_E_SIGN_TEMPLATES, {
        templates: {
          byId: entities.eSignTemplates || {},
          allIds: result
        }
      });
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [E_SIGN_UPLOAD_DOCUMENT_TEMPLATE]: async (context, {
    applicationId,
    clientUsername,
    classification,
    file,
    fileName
  }) => {
    try {
      var _context;
      const name = fileName || _replaceAllInstanceProperty(_context = file.name).call(_context, " ", "-");
      const signed = await getSignedURL(name);
      await putS3Data(file, signed.url, signed.contentType);
      await markUploadCompleted(clientUsername, applicationId.toString(), classification, "", signed.documentId);
      return {
        fileName: name,
        documentId: signed.documentId
      };
    } catch (e) {
      Err.handle(e);
    }
  },
  [E_SIGN_DELETE_TEMPLATE]: async (context, eSignTemplateId) => {
    try {
      context.commit(E_SIGN_REMOVE_TEMPLATE, eSignTemplateId);
      await deleteEsignTemplate(eSignTemplateId);
      Amplitude.logEvent("E-Sign: Deleted Template", {
        eSignTemplateId
      });
    } catch (e) {
      const templateFailedToDelete = context.state.eSign.templates.byId[eSignTemplateId];
      context.commit(ADD_E_SIGN_TEMPLATE, templateFailedToDelete);
      Err.handle(e);
    }
  },
  [CHANGE_MORTGAGE_LENDER]: async (context, {
    mortgageType,
    lenderName
  }) => {
    context.commit(SET_MORTGAGE_LENDER, {
      mortgageType: MORTGAGE_TYPE_PARSER[mortgageType],
      lenderName
    });
  },
  [LOAD_FILOGIX_SUBMISSIONS]: async (context, {
    applicationId,
    clientUsername
  }) => {
    try {
      const {
        deals
      } = await getFilogixDeals(applicationId, clientUsername);
      const {
        entities,
        result
      } = normalize(deals, [filogixSubmissionSchema]);
      context.commit(SET_FILOGIX_DEALS, {
        filogixSubmissions: {
          byId: entities.filogixSubmissions || {},
          allIds: result
        },
        applicationId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_FILOGIX_SUBMISSION]: async (context, {
    applicationId,
    clientUsername,
    filogixSubmissionId,
    details
  }) => {
    try {
      await updateFilogixDeal(applicationId, clientUsername, filogixSubmissionId, details);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [UPDATE_FILOGIX_SUBMISSION_STATUS]: async (context, {
    applicationId,
    clientUsername,
    filogixSubmissionId,
    status
  }) => {
    const {
      status: oldStatus
    } = context.state.filogix.submissions.byApplication[applicationId].byId[filogixSubmissionId];
    try {
      context.commit(SET_FILOGIX_DEAL_STATUS, {
        applicationId,
        filogixSubmissionId,
        status
      });
      await updateFilogixDealStatus(applicationId, clientUsername, status);
    } catch (e) {
      context.commit(SET_FILOGIX_DEAL_STATUS, {
        applicationId,
        filogixSubmissionId,
        status: oldStatus
      });
      Err.handle(e);
    }
  },
  [TOGGLE_FILOGIX_SUBMISSION_PROGRESS]: async (context, {
    applicationId,
    submitting
  }) => {
    context.commit(SET_FILOGIX_SUBMITTING, {
      submitting: submitting != null ? submitting : !submitting,
      applicationId
    });
  },
  [SUBMIT_TO_FILOGIX]: async (context, {
    applicationId,
    clientUsername,
    filogixPassword
  }) => {
    return submitFilogixDeal(applicationId, clientUsername, filogixPassword);
  },
  [SYNC_WITH_FILOGIX]: async (context, {
    applicationId,
    clientUsername,
    filogixSubmissionId
  }) => {
    try {
      await syncFilogixDealApplication(applicationId, clientUsername, filogixSubmissionId);
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_SCHEMA]: async context => {
    const schema = await getSchema();
    context.commit(SET_SCHEMA, schema);
  },
  [LOAD_CUSTOMIZATION_SCHEMA]: async (context, {
    isBrokerage = false
  }) => {
    let schema = {};
    if (isBrokerage) {
      schema = await getCustomizationBrokerageSchema();
    } else {
      schema = await getCustomizationSchema();
    }
    context.commit(SET_CUSTOMIZATION_SCHEMA, schema);
  },
  [SET_APPLICATION_STATUS]: async (context, {
    submissionStatus,
    applicationStatus
  }) => {
    const currentApplication = context.getters["CURRENT_APPLICATION"];
    const {
      emptyApplication
    } = context.state;
    const {
      flow,
      applicationId
    } = currentApplication;
    const newApplicationStatus = applicationStatus != null ? applicationStatus : MAP_COMPLETE_TO_APPLICATION_STATUS[submissionStatus];
    context.commit(SET_CURRENT_APPLICATION, {
      application: _objectSpread(_objectSpread({}, currentApplication), {}, {
        applicationStatus: newApplicationStatus,
        appSubStatus: submissionStatus
      }),
      emptyApplication: emptyApplication[flow],
      applicationId
    });
  },
  [DELETE_APPLICATION]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      await deleteApplication(clientUsername, applicationId);
      context.commit(REMOVE_APPLICATION, {
        clientUsername,
        applicationId
      });
    } catch (e) {
      Err.handle(e, {}, "failedToDeleteApplication");
    }
  },
  [LOAD_MUTED_AUTOMATIONS]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const mutedAutomations = await getMutedAutomations(clientUsername, applicationId);
      context.commit(SET_MUTED_AUTOMATIONS, {
        mutedAutomations,
        applicationId
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [UPDATE_MUTED_AUTOMATIONS]: async (context, {
    clientUsername,
    applicationId,
    mutedAutomations
  }) => {
    const currentMutedAutomations = context.state.mutedAutomations.byApplication[applicationId];
    try {
      context.commit(SET_MUTED_AUTOMATIONS, {
        mutedAutomations,
        applicationId
      });
      await updateMutedAutomations(clientUsername, applicationId, mutedAutomations);
    } catch (e) {
      context.commit(SET_MUTED_AUTOMATIONS, {
        mutedAutomations: currentMutedAutomations,
        applicationId
      });
      Err.handle(e);
    }
  },
  [LOAD_APPLICATION_SUBSCRIPTION_INFO]: async (context, {
    clientUsername,
    applicationId,
    agentUsername
  }) => {
    try {
      const {
        subscription = null
      } = await getApplicationData(clientUsername, applicationId, agentUsername);
      context.commit(SET_APPLICATION_SUBSCRIPTION_INFO, {
        subscription
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [SWAP_APPLICANT]: async (context, {
    clientUsername,
    applicationId,
    applicantIndex
  }) => {
    try {
      const {
        newAppId,
        newClientUsername
      } = await swapApplicants(clientUsername, applicationId, applicantIndex);
      Amplitude.logEvent("Applications - swapped applicant information", {
        page: "clients-applications",
        applicationId,
        applicantIndex
      });
      if (newAppId || newClientUsername) {
        context.commit(REDIRECT_TO_CLIENT, {
          clientUsername: newClientUsername,
          applicationId: newAppId
        });
        return false;
      }
      return true;
    } catch (e) {
      Err.handle(e);
      throw e;
    }
  },
  [LOAD_REQUESTED_PACKAGES]: async (context, {
    clientUsername,
    applicationId
  }) => {
    try {
      const {
        clientApplicationRequests
      } = await getUserDataRequest(applicationId, clientUsername, "consolidated-request");
      const {
        entities,
        result
      } = normalize(clientApplicationRequests, [requestedPackagesSchema]);
      context.commit(REQUEST_PACKAGE_SET_REQUESTED_PACKAGES, {
        applicationId,
        requestedPackages: {
          byId: entities.requestedPackages || {},
          allIds: result
        }
      });
    } catch (e) {
      Err.handle(e);
    }
  },
  [SYNC_AGENT_FROM_EXPERT]: async context => {
    try {
      const syncAgentResult = await syncSubmissionAgentFromExpert();
      if (syncAgentResult != null && syncAgentResult.shouldVerify) return syncAgentResult;
      const {
        submissionAgents = []
      } = await getSubmissionAgents();
      const {
        entities,
        result
      } = normalize(submissionAgents, [submissionAgentsSchema]);
      context.commit(SET_SUBMISSION_AGENTS, {
        submissionAgents: {
          byId: entities.submissionAgents || {},
          allIds: result
        }
      });
    } catch (e) {
      var _e$responseJSON;
      Err.handle(e);
      if (((_e$responseJSON = e.responseJSON) == null ? void 0 : _e$responseJSON.code) === "InvalidOperationException") throw e;
    }
  },
  [LOAD_APPLICATION_SYNC_STATUS]: async (context, {
    applicationId,
    clientUsername
  }) => {
    try {
      var _syncHistory$;
      const {
        syncing,
        expertApplicationId,
        syncHistory
      } = await getApplicationSyncStatus({
        applicationId,
        clientUsername,
        latest: true
      });
      const status = {
        syncing,
        expertApplicationId,
        details: (_syncHistory$ = syncHistory == null ? void 0 : syncHistory[0]) != null ? _syncHistory$ : {}
      };
      context.commit(SET_APPLICATION_SYNC_STATUS, {
        applicationId,
        status
      });
    } catch (e) {
      // Ignore sync errors, just report to amplitude
      Amplitude.logHandledError(e);
    }
  },
  [LOAD_APPLICATION_SYNC_HISTORY]: async (context, {
    applicationId,
    clientUsername,
    limit = 10,
    offset = 0,
    eventType = null
  }) => {
    try {
      const {
        syncHistory
      } = await getApplicationSyncStatus({
        applicationId,
        clientUsername,
        offset,
        limit,
        eventType
      });
      return syncHistory;
    } catch (e) {
      // Ignore sync errors, just report to amplitude
      Amplitude.logHandledError(e);
      return [];
    }
  },
  [RETRY_APPLICATION_SYNC]: async (context, {
    applicationId,
    clientUsername
  }) => {
    try {
      await retryApplicationSync(applicationId, clientUsername);
    } catch (e) {
      // Ignore sync errors, just report to amplitude
      Amplitude.logHandledError(e);
    }
  },
  [SYNC_APPLICATION_TO_CLIENT_PROFILE]: async (context, {
    applicationId,
    clientUsername,
    clientProfileId
  }) => {
    try {
      await syncApplicationToClientProfile(applicationId, clientUsername, clientProfileId);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [DEAL_IMPORT_COMPLETE_NOTIFICATION]: async (context, {
    data,
    notification: {
      type,
      message,
      title
    }
  }) => {
    showToast(type, message, title, _objectSpread(_objectSpread({}, EXTENDED_TOASTR_OPTIONS), {}, {
      onclick: () => {
        window.open(data == null ? void 0 : data.url, "_blank");
      }
    }));
  },
  [RESET_DEAL_TYPE]: context => {
    context.commit(SET_DEAL_TYPE);
  },
  [SUBMIT_INSURANCE_REQUEST]: async (context, {
    clientUsername,
    data
  }) => {
    try {
      const res = await submitInsuranceRequest(clientUsername, context.getters["CURRENT_APPLICATION_ID"], data);
      return {
        succeeded: true,
        res
      };
    } catch (e) {
      const errRes = e && e.response && e.response.data ? e.response.data : e.response || e;
      Err.handle(e);
      return {
        succeeded: false,
        res: errRes
      };
    }
  },
  [GET_INSURANCE_SUBMISSIONS_HISTORY]: async (context, clientUsername) => {
    try {
      const applicationId = context.getters["CURRENT_APPLICATION_ID"];
      const submissions = await getInsuranceSubmissionsHistory(applicationId, clientUsername);
      context.commit(SET_INSURANCE_SUBMISSION_HISTORY, submissions.insuranceSubmissionsHistory);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [LOAD_INSURANCE_PROVIDERS]: async context => {
    try {
      const insuranceProviders = await getInsuranceProviders();
      context.commit(SET_INSURANCE_PROVIDERS, insuranceProviders.providers);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  }
};